import { render, staticRenderFns } from "./ViewPatientDetails.vue?vue&type=template&id=2fc72773&"
import script from "./ViewPatientDetails.vue?vue&type=script&lang=js&"
export * from "./ViewPatientDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports